/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Form, Input, Typography } from "antd";
import { ShareDesignDetails } from "interfaces/ShareDesign/IShareDesign";

const { Title } = Typography;

interface BillingInformationProps {
  onHandleBillingForm: (event: any) => void;
  billingInformation: ShareDesignDetails;
}

const BillingInformation: React.FC<BillingInformationProps> = ({
  onHandleBillingForm,
  billingInformation,
}: BillingInformationProps) => {
  return (
    <div className="billing-information mb-3">
      <Title level={4} className="section-heading">
        Billing Information
      </Title>
      <Form.Item
        label="Purchase Order #"
        name="purchaseOrderNo"
        className="input-label"
        data-test-selector={"lblPurchaseOrder"}
      >
        <Input
          className="form-input"
          data-test-selector={"txtPurchaseOrder"}
          name="purchaseOrderNo"
          onChange={onHandleBillingForm}
          maxLength={50}
          status={billingInformation?.purchaseOrderNo?.length > 50 ? "error" : ""}
        />
        <span
          style={
            billingInformation?.purchaseOrderNo?.length > 50
              ? { float: "right", color: "red", fontWeight: "600", fontSize: "12px" }
              : { float: "right", fontWeight: "600", fontSize: "12px" }
          }
        >
          {billingInformation?.purchaseOrderNo?.length} / 50
        </span>
      </Form.Item>
      <Form.Item
        label="Billing Account #"
        name="billingAccountNo"
        className="input-label"
        data-test-selector={"lblBillingAccount"}
      >
        <Input
          className="form-input"
          data-test-selector={"txtBillingAccount"}
          name="billingAccountNo"
          maxLength={50}
          onChange={onHandleBillingForm}
          status={billingInformation?.billingAccountNo?.length > 50 ? "error" : ""}
        />
        <span
          style={
            billingInformation?.billingAccountNo?.length > 50
              ? { float: "right", color: "red", fontWeight: "600", fontSize: "12px" }
              : { float: "right", fontWeight: "600", fontSize: "12px" }
          }
        >
          {billingInformation?.billingAccountNo?.length} / 50
        </span>
      </Form.Item>
    </div>
  );
};

export default BillingInformation;
